export default "__VITE_ASSET__Fs01gdGJ__"